var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-container"},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("$info-warning")]),_c('span',{staticClass:"warning-container__info"},[_vm._v(_vm._s(_vm.warningInfo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }